import { render } from "./AiInsightList.vue?vue&type=template&id=48e03d5c&scoped=true"
import script from "./AiInsightList.vue?vue&type=script&lang=js"
export * from "./AiInsightList.vue?vue&type=script&lang=js"

import "./AiInsightList.vue?vue&type=style&index=0&id=48e03d5c&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e03d5c"]])

export default __exports__